module.exports = __webpack_public_path__ + "static/media/image_12.1806ba92.png";